<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="OT">Contents</p>
<p class="CON2"><a href="#/CoverImage">Cover</a></p>
<p class="CON2"><a href="#/Wright_The_Lord_and_His_Prayer_text1#toc_marker-2">Dedication</a></p>
<p class="CON2AFTER" id="toc1"><a href="#/Wright_The_Lord_and_His_Prayer_text2#toc_marker-3">Prologue</a></p>
<p class="CON2" id="toc2"><a href="#/Wright_The_Lord_and_His_Prayer_text3#toc_marker-4">1. Our Father in Heaven</a></p>
<p class="CON2" id="toc3"><a href="#/Wright_The_Lord_and_His_Prayer_text4#toc_marker-5">2. Thy Kingdom Come</a></p>
<p class="CON2" id="toc4"><a href="#/Wright_The_Lord_and_His_Prayer_text5#toc_marker-6">3. Give Us This Day</a></p>
<p class="CON2" id="toc5"><a href="#/Wright_The_Lord_and_His_Prayer_text6#toc_marker-7">4. Forgive Us Our Trespasses</a></p>
<p class="CON2" id="toc6"><a href="#/Wright_The_Lord_and_His_Prayer_text7#toc_marker-8">5. Deliver Us from Evil</a></p>
<p class="CON2" id="toc7"><a href="#/Wright_The_Lord_and_His_Prayer_text8#toc_marker-9">6. The Power and the Glory</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?432d8fbd